//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from '@careinfo/layout';

import { NavLink, Outlet, useParams } from 'react-router-dom';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import NoticeIcon from '../Icons/NoticeIcon';
import NotificationIcon from '../Icons/NotificationIcon';
import APIS from '../constant/EndPoint';
import useGetHook from '../customHooks/useGetHook';
import { getKey } from '../helpers/sessionKey';
import WelcomeIcon from '../Icons/WelcomeIcon';
import OverViewIcon from '../Icons/OverViewIcon';

const DashboardLayout = () => {
  const shouldShowWelcome = getKey('shouldShowWelcome');
  const { slug } = useParams<{ slug: string }>();
  const { data, isLoading } = useGetHook({
    url: APIS.DELIVERY_PARTNER,
    queryKey: [''],
    params: {},
  });

  const transformedData =
    Array.isArray(data) && data?.length > 0
      ? [
        {
          name: 'Dashboard',
          href: '',
          icon: '',
          children: [
            ...(shouldShowWelcome === 'true' || shouldShowWelcome === null
              ? [
                {
                  name: 'Welcome',
                  href: '/delivery',
                  icon: WelcomeIcon,
                  activeIcon: WelcomeIcon,
                },
                {
                  name: 'Overview',
                  href: '/delivery/overview',
                  icon: OverViewIcon,
                  activeIcon: OverViewIcon,
                },
              ]
              : [
                {
                  name: 'Overview',
                  href: '/delivery',
                  icon: OverViewIcon,
                  activeIcon: OverViewIcon,
                },
              ]),
          ],
        },
        {
          name: 'Delivery Partners',
          href: '',
          icon: '',
          children: data.map((item) => ({
            name: item.name,
            href: `/delivery/${item.slug}`,
            icon: NoticeIcon,
            activeIcon: NoticeIcon,
          })),
        },
        {
          name: 'Operation',
          href: '',
          icon: '',
          children: [
            {
              name: 'Order',
              href: '/delivery/order',
              icon: NotificationIcon,
              activeIcon: NotificationIcon,
            },
          ],
        },
      ]
      : [];

  const navigation = [
    {
      name: 'Setting',
      href: '/',
      icon: '',
      children: [
        {
          name: 'Status',
          href: `/delivery/${slug}/status`,
          icon: OverViewIcon,
          activeIcon: OverViewIcon,
          children: [],
        },
        {
          name: 'Pickup Branch',
          href: `/delivery/${slug}/branch`,
          icon: OverViewIcon,
          activeIcon: OverViewIcon,
          children: [],
        },
        {
          name: 'Location',
          href: `/delivery/${slug}/location`,
          icon: OverViewIcon,
          activeIcon: OverViewIcon,
          children: [],
        },
        {
          name: 'Setting',
          href: `/delivery/${slug}/setting`,
          icon: OverViewIcon,
          activeIcon: OverViewIcon,
          children: [],
        },
      ],
    },
  ];

  return (
    <DashboardLayoutService navigation={transformedData}>
      <div className={tw` p-2 overflow-y-auto`}>
        {slug ?
          <div className={tw`flex h-[calc(100vh-12vh)]`}>
            {/* Sidebar */}
            <div className={tw`h-full  w-[12rem] hover:overflow-auto flex-shrink-0`}>
              <div
                className={tw`rounded-md h-full overflow-auto p-2`}
                style={{
                  background:
                    'linear-gradient(135deg,var(--primary-light), rgba(246, 172, 208, 0.03) 82.72%, rgba(248, 206, 226, 0) 100%)',
                }}
              >
                <ul>
                  {navigation.map((item, index) => (
                    <li key={index}>
                      <span className={tw`block font-[18px] text-gray-500`}>
                        {item.name}
                      </span>
                      {item.children.length > 0 && (
                        <ul className={tw`ml-2`}>
                          {item.children.map((subMenu, subIndex) => (
                            <NavLink
                              key={subIndex}
                              to={subMenu.href}
                              className={({ isActive, isPending }) =>
                                tw`${isActive
                                  ? tw`bg-primary-active rounded text-primary`
                                  : isPending
                                    ? tw`text-indigo-100 hover:bg-indigo-600`
                                    : ''
                                  } text-gray-700 my-1 cursor-pointer px-2 py-[4px] flex `
                              }
                            >
                              <subMenu.icon
                                color={
                                  location.pathname === subMenu.href
                                    ? 'var(--primary)'
                                    : 'gray'
                                }
                              />
                              <span className={tw`ml-4`}>{subMenu.name}</span>
                            </NavLink>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className={tw`h-full overflow-auto p-2 w-full flex-grow `}>
              <Outlet />
            </div>
          </div> :
          <Outlet />
        }
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
